module.exports = __webpack_public_path__ + "media/עז.1da3d1a1.mp3";